import { Redirect, BrowserRouter as Router, Route } from "react-router-dom";
import { AnimatedSwitch } from "react-router-transition";
import React, { Suspense, lazy } from "react";
import { useTranslation } from "react-i18next";
import Loading from "../components/Loading/Loading";
import Spacer from "../components/Spacer/Spacer";
import ScrollTop from "../pages/ScrollTop";
import TripPdf from "../pages/TripPdf";
import FetchData from "./FetchData";
import AppTitle from "../pages/AppTitle";
import NewNavbar from "../components/NewNavbar";
import NewFooter from "../components/Footer/NewFooter";
import ModalPopup from "../components/ModalPopup/ModalPopup";
import GlobalStyles from "../styles/GlobalStyles";
import GlobalDataProvider from "./GlobalDataProvider";
import Home from "../pages/Home";

const TagsSearch = lazy(() => import("../pages/TagsSearch"));
const POI = lazy(() => import("../pages/POI"));
const Search = lazy(() => import("../pages/Search"));
const Deals = lazy(() => import("../pages/Deals"));
const Favorites = lazy(() => import("../pages/Favorites"));
const Contactp = lazy(() => import("../pages/Contactp"));
const Preference = lazy(() => import("../pages/Preference"));
const Destination = lazy(() => import("../pages/Destination"));
const Event = lazy(() => import("../pages/Event"));
const Circuit = lazy(() => import("../pages/Circuit"));
const Experience = lazy(() => import("../pages/Experience"));
const About = lazy(() => import("../pages/About"));
const Deal = lazy(() => import("../pages/Deal"));
const Whoarewe = lazy(() => import("../pages/Whoarewe"));
const Doc = lazy(() => import("../pages/Doc"));
const PracticalInfoPage = lazy(() => import("../pages/PracticalInfoPage"));
const Policy = lazy(() => import("../pages/Policy"));
const ThingsCategory = lazy(() => import("../pages/ThingsCategory"));
const QuizPage = lazy(() => import("../pages/quiz"));

export default function App() {
  const [contact, setContact] = React.useState(false);
  const { t } = useTranslation();

  React.useEffect(() => {
    setTimeout(() => window.scrollTo(0, 0), 500);
  }, []);

  return (
    <>
      <GlobalDataProvider />
      <GlobalStyles />
      <Router>
        <div style={{ position: "relative" }}>
          <header>
            <NewNavbar contact={contact} setContact={setContact} />
            {/* {isMobile().phone && <MobileNav />} */}
          </header>

          <main>
            <AnimatedSwitch className="switch-wrapper">
              <Route key="Quiz" exact path="/quiz">
                <Suspense fallback={<Loading />}>
                  <QuizPage />
                </Suspense>
              </Route>
              <Route exact path="/">
                <Redirect to={`/en`} />
              </Route>

              <Route key="Home" exact path="/:locale?">
                <Home />
              </Route>
              <Route key="POI" exact path="/:locale/poi/:id">
                <Suspense fallback={<Loading />}>
                  <POI />
                </Suspense>
              </Route>
              <Route key="Deal" exact path="/:locale/deal/:id">
                <Suspense fallback={<Loading />}>
                  <Deal />
                </Suspense>
              </Route>

              <Route key="Search" exact path="/:locale/search">
                <Suspense fallback={<Loading />}>
                  <Search />
                </Suspense>
              </Route>
              <Route key="ThingsCategory" exact path="/:locale/discover/:slug">
                <Suspense fallback={<Loading />}>
                  <ThingsCategory />
                </Suspense>
              </Route>
              <Route key="Deals" exact path="/:locale/deals">
                <Suspense fallback={<Loading />}>
                  <Deals />
                </Suspense>
              </Route>
              <Route key="Favorites" exact path="/:locale/fav">
                <Suspense fallback={<Loading />}>
                  <Favorites />
                </Suspense>
              </Route>
              <Route key="Contact" exact path="/:locale/contact">
                <Suspense fallback={<Loading />}>
                  <Contactp />
                </Suspense>
              </Route>
              <Route key="Destination" exact path="/:locale/destination/:id">
                <Suspense fallback={<Loading />}>
                  <Destination />
                </Suspense>
              </Route>
              <Route key="Preference" exact path="/:locale/preference/:id">
                <Suspense fallback={<Loading />}>
                  <Preference />
                </Suspense>
              </Route>
              <Route key="Event" exact path="/:locale/event/:id">
                <Suspense fallback={<Loading />}>
                  <Event />
                </Suspense>
              </Route>
              <Route key="Circuit" exact path="/:locale/circuit/:id">
                <Suspense fallback={<Loading />}>
                  <Circuit />
                </Suspense>
              </Route>
              <Route key="Experience" exact path="/:locale/experience/:id">
                <Suspense fallback={<Loading />}>
                  <Experience />
                </Suspense>
              </Route>
              <Route key="About" exact path="/:locale/about">
                <Suspense fallback={<Loading />}>
                  <About />
                </Suspense>
              </Route>
              <Route key="lookfor" exact path="/:locale/lookfor/:id">
                <Suspense fallback={<Loading />}>
                  <TagsSearch />
                </Suspense>
              </Route>
              <Route key="lookfor" exact path="/:locale/whoarewe">
                <Suspense fallback={<Loading />}>
                  <Whoarewe />
                </Suspense>
              </Route>
              <Route key="mapsguides" exact path="/:locale/mapsguides">
                <Suspense fallback={<Loading />}>
                  <Doc />
                </Suspense>
              </Route>
              <Route key="practical-info" exact path="/:locale/practical-info">
                <Suspense fallback={<Loading />}>
                  <PracticalInfoPage />
                </Suspense>
              </Route>
              <Route key="policy" exact path="/:locale/policy">
                <Suspense fallback={<Loading />}>
                  <Policy />
                </Suspense>
              </Route>

              <Route
                key="pdf"
                exact
                path="/:locale/pdf"
                render={(props) => (
                  <Suspense fallback={<Loading />}>
                    <TripPdf {...props} />
                  </Suspense>
                )}
              />
            </AnimatedSwitch>
          </main>
          <Spacer bottom="124px" />
          <NewFooter />
          <ModalPopup />
          <FetchData />
          <ScrollTop />
          <AppTitle title={t("AppName")} />
        </div>
      </Router>
    </>
  );
}
